import { render, staticRenderFns } from "./ConsignorCreate.vue?vue&type=template&id=2f342cf7"
import script from "./ConsignorCreate.vue?vue&type=script&lang=js"
export * from "./ConsignorCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports